<script setup>
import { onBeforeMount, ref } from 'vue';
import { storeToRefs } from 'pinia'
import SidebarContainer from './SidebarContainer.vue';
import { textColor, borderColor } from '@constants/brands.js';
import SidebarPlaylists from '@collections/Playlists/SidebarPlaylists.vue';
//Icons
import MusoraIcon from '@units/MusoraIcons/MusoraIcon.vue';
import SearchInput from './SearchInput.vue';
import { useUserStore } from '@stores/user';

const emit = defineEmits(['onCollapseSidebar']);
const handleCollapse = (val) => {
  emit('onCollapseSidebar', val)
};

const props = defineProps({
  isSidebarCollapsed: Boolean,
  isSidebarHidden: Boolean,
  isLive: {
    type: Boolean,
    default: false,
  },
  forceSidebarHidden: {
    type: Boolean,
    default: false,
  }
});

const userStore = useUserStore();
const { brand } = storeToRefs(userStore)

const sidebarNavigationLinks = ref([]);

const activePath = (path) => {
  let windowPathArray = window.location.pathname.split('/');
  let pathArray = path.split('/');

  //Page Check
  if (pathArray[3] !== '500-songs-in-5-days' && windowPathArray[3] !== '500-songs-in-5-days' && pathArray[3] !== 'chord-resources' && windowPathArray[3] !== 'chord-resources') {
    return windowPathArray[2] === pathArray[2];
  }

  // special case for guitareo 500 songs
  if (windowPathArray[3] === '500-songs-in-5-days' && pathArray[3] === '500-songs-in-5-days') {
    return true;
  }

    // special case for guitareo chords
    if (windowPathArray[3] === 'chord-resources' && pathArray[3] === 'chord-resources') {
        return true;
    }
}

onBeforeMount(() => {
  sidebarNavigationLinks.value = window.sidebarNavigationLinks;
});
</script>

<template>
  <SidebarContainer :isSidebarCollapsed="isSidebarCollapsed" :isSidebarHidden="isSidebarHidden" :brand="brand"
    :forceSidebarHidden="forceSidebarHidden">
    <!-- Sidebar Search -->
    <SearchInput :isSidebarCollapsed="isSidebarCollapsed" :brand="brand" @onCollapse="handleCollapse" />

    <!-- Sidebar Link Sections -->
    <section v-for="(section, i) in sidebarNavigationLinks" :key="i"
      class="tw-border-b dark:tw-border-b-[#1E364A]">
      <ul>
        <li v-for="(link, j) in section" :key="j" :class="[activePath(link.path) ? textColor[brand] : '']">
          <a :href="`${link.path}`"
             :target="link.name === 'Shop' ? '_blank' : '_self'"
             :title="[ isSidebarCollapsed ? `${link.name}`: '' ]"
             class="tw-text-sm tw-h-[42px] tw-mb-[5px] tw-flex tw-items-center tw-justify-between tw-pl-1 tw-border-l-4 dark:hover:tw-bg-[#102230] hover:tw-bg-[#F5F5F6]"
             :class="[activePath(link.path) ? `tw-font-bold ${textColor[brand]} ${borderColor[brand]}` : 'tw-border-transparent tw-text-[#00101D] dark:tw-text-white']"
          >
            <div class="tw-flex tw-items-center">
              <musora-icon
                 :icon-name="activePath(link.path) ? `${link.icon}-filled` : `${link.icon}`"
                 class="tw-w-[24px] tw-mx-4"
              />
              <span class="tw-transition tw-whitespace-nowrap" :class="[isSidebarCollapsed ? 'md:tw-opacity-0' : 'tw-opacity-100']">
                <span class="tw-capitalize">{{ link.name }}</span>
              </span>
            </div>

            <!-- Live Indicator -->
            <a v-if="link.name === 'Live' && isLive" :href="`/${brand}/live`" class="tw-relative tw-mr-5">
              <span class="tw-animate-grow-shrink tw-blur-sm tw-origin-center tw-absolute tw-left-0 tw-top-0 tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-[#F71B26] tw-opacity-75"></span>
              <span class="tw-relative tw-whitespace-nowrap tw-base tw-pt-[2px] tw-text-sm tw-pb-0 tw-px-[3px] tw-rounded tw-leading-none tw-text-white tw-bg-[#DC2626] tw-uppercase tw-font-bebas-neue">On-Air</span>
            </a>
          </a>
        </li>
      </ul>
    </section>

    <!-- Playlists Section -->
    <sidebar-playlists
      :isSidebarCollapsed="isSidebarCollapsed"
      :isActivePath="activePath(`/${brand}/playlists`)"
    >
    </sidebar-playlists>

  </SidebarContainer>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 150ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
